import { Link } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-6 text-center" data-testid="not-found-page">
      <p className="font-display text-7xl font-semibold text-[color:var(--bp-teal)]">404</p>
      <h1 className="mt-5 font-display text-3xl font-semibold text-[color:var(--bp-cream)]">This page has moved on.</h1>
      <p className="mt-3 max-w-md text-[15px] text-[color:var(--bp-text-muted)]">The page you're looking for isn't here — but our market intelligence is.</p>
      <Link to="/" className="mt-8 inline-flex items-center gap-2 rounded-full bg-[color:var(--bp-teal)] px-6 py-3.5 text-sm font-semibold text-[color:var(--bp-bg)]">
        <Home className="h-4 w-4" /> Back to home
      </Link>
    </div>
  );
}
